
import { VTabItem } from "vuetify/lib";

export default VTabItem.extend({});
